// extracted by mini-css-extract-plugin
export default {"container":"InfoPage_container__kpvqi","title":"InfoPage_title__5Ndu4"};